var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInNeedOfHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C04B42"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_14408)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_14408",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H32V32H8V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_14408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5261 27.9355L29.9688 26.3783",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1094 28.9268L27.831 31.6484",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7467 17.8828L21.7445 15.1361C21.5833 14.6943 21.3275 14.293 20.9949 13.9605L19.3004 12.2659C18.8242 11.7897 18.0521 11.7897 17.5759 12.2659C17.2832 12.5587 17.1704 12.9631 17.2375 13.3418",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7779 25.1875L27.3398 23.7495",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3047 22.9594V23.5508",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47656 12.2947L10.9113 14.7295",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3041 25.2348V25.709C17.3041 26.2641 17.7358 26.7369 18.2906 26.7566C18.873 26.7773 19.3516 26.3113 19.3516 25.7335V26.8339C19.3516 27.3993 19.81 27.8576 20.3754 27.8576C20.9408 27.8576 21.3991 27.3993 21.3991 26.8339V27.3588C21.3991 27.9139 21.8308 28.3867 22.3855 28.4064C22.968 28.4271 23.4466 27.9611 23.4466 27.3833V27.9313C23.4466 28.4967 23.905 28.9551 24.4703 28.9551C25.0357 28.9551 25.4941 28.4967 25.4941 27.9313V21.901L27.1948 23.6048C27.6656 24.077 28.4286 24.0831 28.907 23.6186C29.395 23.1447 29.4008 22.3631 28.9198 21.8821L26.8813 19.8435C26.5487 19.511 26.1475 19.2551 25.7056 19.0939L20.9527 17.3597L12.4219 8.35108",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8906 21.7233C14.8906 22.2887 15.349 22.7471 15.9144 22.7471H17.1642C17.7296 22.7471 18.188 22.2887 18.188 21.7233C18.188 21.1579 17.7296 20.6996 17.1642 20.6996H15.9144C15.349 20.6996 14.8906 21.1579 14.8906 21.7233Z",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 19.6764C13.2422 20.2419 13.7005 20.7002 14.2659 20.7002H16.3535C16.9189 20.7002 17.3772 20.2419 17.3772 19.6764C17.3772 19.111 16.9189 18.6527 16.3535 18.6527H14.2659C13.7005 18.6527 13.2422 19.111 13.2422 19.6764Z",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0234 17.6286C12.0234 18.194 12.4818 18.6523 13.0472 18.6523H15.1588C15.7242 18.6523 16.1826 18.194 16.1826 17.6286C16.1826 17.0632 15.7242 16.6048 15.1588 16.6048H13.0472C12.4818 16.6048 12.0234 17.0632 12.0234 17.6286Z",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5838 14.5614C11.0617 14.608 10.6523 15.0465 10.6523 15.5807C10.6523 16.1461 11.1107 16.6045 11.6761 16.6045H13.285C13.8504 16.6045 14.3087 16.1461 14.3087 15.5808C14.3087 15.0154 13.8504 14.557 13.285 14.557H13.2679",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3516 25.5938V24.599",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3984 26.6934V25.1067",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4453 27.2432V25.81",
    stroke: "#C04B42",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_14408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInNeedOfHelp);
export default __webpack_public_path__ + "static/media/in-need-of-help.60b76ec95de6942a4a02c44f76e9d014.svg";
export { ForwardRef as ReactComponent };